import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", { class: "font-bold text-white bg-primary" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-left" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "User"),
    /*#__PURE__*/_createElementVNode("th", { class: "w-20 p-2 text-right" }, "Reigns"),
    /*#__PURE__*/_createElementVNode("th", { class: "w-20 p-2 text-right" }, "Wins")
  ])
], -1)
const _hoisted_3 = { class: "p-2" }
const _hoisted_4 = { class: "p-2 text-right" }
const _hoisted_5 = { class: "p-2 text-right" }

import { FactionStatistic } from '@/typings/faction';
import { PropType } from 'vue';
import User from '../User/User.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  rankings: {
    type: Array as PropType<FactionStatistic[]>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rankings, (ranking) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: ranking.User.Uuid
        }, [
          _createElementVNode("td", _hoisted_3, [
            _createVNode(User, {
              user: ranking.User
            }, null, 8, ["user"])
          ]),
          _createElementVNode("td", _hoisted_4, _toDisplayString(ranking.Reigns), 1),
          _createElementVNode("td", _hoisted_5, _toDisplayString(ranking.Wins), 1)
        ]))
      }), 128))
    ])
  ]))
}
}

})